import React, { useEffect, useState } from "react";
import { PortalsSidebar, PortalsToolbarButton } from "./PortalsSidebar";
import PropTypes from "prop-types";
import { isHubsRoomUrl } from "../../utils/media-url-utils";

export function PortalsSidebarContainer({ onClose, portals, className }) {
  const [portalsUrls, setPortalsUrls] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Remove duplicates using Set
    setLoading(true);
    const nonDuplicatePortals = [...new Set(portals)];

    // Asynchronously remove invalid portals
    Promise.all(nonDuplicatePortals.map(portal => isHubsRoomUrl(portal))).then(results => {
      const validPortals = nonDuplicatePortals.filter((portal, index) => results[index]);
      setPortalsUrls(validPortals);
      setLoading(false);
    });
  }, [portals]);

  return <PortalsSidebar onClose={onClose} portals={portalsUrls} className={className} loading={loading} />;
}

export function PortalsToolbarButtonContainer(props) {
  return <PortalsToolbarButton {...props} />;
}

PortalsSidebarContainer.propTypes = {
  onClose: PropTypes.func,
  portals: PropTypes.array,
  className: PropTypes.string
};
